class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      const isPriceInput = event.target.closest('.facets__price');
      const isMobileFacets = event.target.closest('#FacetFiltersFormMobile');
      
      // Don't auto-submit for price inputs or mobile facets
      if (!isPriceInput && !isMobileFacets) {
        this.debouncedOnSubmit(event);
      }
    });

  // Add listeners for price apply buttons
  this.querySelectorAll('[data-price-apply]').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      this.onSubmitHandler(event);
    });
  });

  // Add listener for mobile facets footer apply button
  this.querySelectorAll('[data-mobile-facets-apply]').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      this.onSubmitHandler(event);
      // Close the mobile facets drawer after submitting
      setTimeout(() => {
        const mobileDrawer = button.closest('.mobile-facets__wrapper');
        if (mobileDrawer) {
          const summary = mobileDrawer.querySelector('summary');
          if (summary) summary.click();
        }
      }, 100);
    });
  });

  // Add listener for mobile facets submenu apply buttons
  this.querySelectorAll('[data-mobile-facets-submenu-apply]').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      // Close the submenu details element (go back to main facets view)
      const detailsElement = button.closest('details');
      if (detailsElement) {
        detailsElement.removeAttribute('open');
      }
    });
  });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Remove overflow-hidden classes when filters are applied
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    
    // Check if this is within a mobile facets submenu
    const mobileSubmenu = this.closest('.mobile-facets__submenu');
    
    // Check if this is a price range facet-remove on desktop
    const isPriceRange = this.closest('.facets__price') || this.closest('.price-reset');
    
    if (mobileSubmenu) {
      // For mobile facets submenu: clear inputs and close the submenu
      const detailsElement = this.closest('details');
      
      // Clear checkboxes/radio buttons in this submenu
      const inputs = detailsElement.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      inputs.forEach(input => {
        if (input.checked) {
          input.checked = false;
        }
      });
      
      // Clear price range inputs if present
      const priceInputs = detailsElement.querySelectorAll('.facets__price input[type="text"]');
      priceInputs.forEach(input => {
        input.value = '';
      });
      
      // Close the submenu (go back to main facets view)
      if (detailsElement) {
        detailsElement.removeAttribute('open');
      }
    } else if (isPriceRange && !mobileSubmenu) {
      // For desktop price range: just clear the inputs without triggering page refresh
      const detailsElement = this.closest('details');
      const priceInputs = detailsElement.querySelectorAll('.facets__price input[type="text"]');
      priceInputs.forEach(input => {
        input.value = '';
      });
    } else {
      // For desktop or active filters: trigger the normal behavior
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);

// 1. Patch Dawn's product grid renderer to re-init the Load More button after every update
(function () {
  const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;

  FacetFiltersForm.renderProductGridContainer = function (html) {
    originalRenderProductGridContainer.call(this, html);

    // Wait a tick for DOM to update (DOMParser is synchronous, but just in case)
    setTimeout(initializeLoadMoreButton, 0);
  };
})();

// 2. Main initializer function
function initializeLoadMoreButton() {
  const grid = document.querySelector('.grid-products');
  const btn = document.getElementById('load-more');
  if (!grid || !btn) return;

  // Remove any existing listeners by cloning (avoids duplicate handlers)
  const btnClone = btn.cloneNode(true);
  btn.parentNode.replaceChild(btnClone, btn);

  // Update data-next-url according to current filters/page
  updateNextUrl(btnClone);

  btnClone.addEventListener('click', function (e) {
    e.preventDefault();
    loadNextPage(btnClone, grid);
  });
}

// 3. Helper to calculate the next page URL
function updateNextUrl(btn) {
  const url = new URL(window.location.href);
  let currentPage = parseInt(url.searchParams.get('page') || '1', 10);
  const totalPages = parseInt(btn.dataset.totalPages, 10);

  if (currentPage >= totalPages) {
    btn.remove(); // No more pages!
    return;
  }

  url.searchParams.set('page', currentPage + 1);
  btn.setAttribute('data-next-url', url.pathname + url.search);
}

function updateCanonicalUrl(newUrl) {
  let canonicalTag = document.querySelector('link[rel="canonical"]');
  if (!canonicalTag) {
    canonicalTag = document.createElement('link');
    canonicalTag.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalTag);
  }
  canonicalTag.setAttribute('href', newUrl);
}

function buildCanonicalUrl() {
  const url = new URL(window.location.href);
  const allowed = ['page', 'q', 'type'];
  const params = new URLSearchParams();
  allowed.forEach(key => {
    if (url.searchParams.has(key)) {
      params.set(key, url.searchParams.get(key));
    }
  });
  
  let canonical = url.origin + url.pathname;
  const search = params.toString();
  if (search) canonical += '?' + search;
  return canonical;
}

// 4. The actual "load more" logic
async function loadNextPage(btn, grid) {
  if (btn.classList.contains('loading')) return;
  const nextUrl = btn.getAttribute('data-next-url');
  if (!nextUrl) return;

  btn.disabled = true;
  btn.classList.add('loading');

  try {
    // Fetch next page HTML
    const res = await fetch(nextUrl);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    // Calculate the highest existing order value
    const existingItems = grid.querySelectorAll('li:not(.featured-image)');
    let maxOrder = 0;
    existingItems.forEach(item => {
      // Try to get order from style.order first, then parse from style attribute
      let order = 0;
      if (item.style.order) {
        order = parseInt(item.style.order, 10);
      } else {
        const styleAttr = item.getAttribute('style');
        const orderMatch = styleAttr?.match(/order:\s*(\d+)/);
        if (orderMatch) {
          order = parseInt(orderMatch[1], 10);
        }
      }
      if (!isNaN(order) && order > maxOrder) maxOrder = order;
    });
    
    console.log('Max order found:', maxOrder, 'Total existing items:', existingItems.length);
    
    // Append only new products and adjust their order values
    const newItems = doc.querySelectorAll('#product-grid li:not(.featured-image)');
    console.log('New items to append:', newItems.length);
    newItems.forEach((item, index) => {
      // Get the current order value from the item
      let currentOrder = 0;
      if (item.style.order) {
        currentOrder = parseInt(item.style.order, 10);
      } else {
        const styleAttr = item.getAttribute('style');
        const orderMatch = styleAttr?.match(/order:\s*(\d+)/);
        if (orderMatch) {
          currentOrder = parseInt(orderMatch[1], 10);
        }
      }
      // Set the new order value by adding the max order from existing items
      const newOrder = maxOrder + currentOrder;
      if (index === 0) {
        console.log('First new item - original order:', currentOrder, 'new order:', newOrder);
      }
      item.style.order = newOrder;
      grid.appendChild(item);
    });
    
    // Update URL to the new page
    const loadedPage = parseInt(new URL(nextUrl, location.origin).searchParams.get('page'), 10);
    window.history.replaceState(null, '', updatePageInURL(loadedPage));
    
    // **Update canonical immediately after changing the browser URL**
    updateCanonicalUrl(buildCanonicalUrl());

    // Update/remove the button
    const totalPages = parseInt(btn.dataset.totalPages, 10);
    if (loadedPage >= totalPages) {
      btn.remove();
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set('page', loadedPage + 1);
      btn.setAttribute('data-next-url', url.pathname + url.search);
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  } catch (err) {
    console.error('Load more failed', err);
    btn.disabled = false;
    btn.classList.remove('loading');
  }
}


// 5. Helper: update browser URL to match current page (optional)
function updatePageInURL(page) {
  const u = new URL(window.location.href);
  u.searchParams.set('page', page);
  return u.pathname + u.search;
}

// 6. On first load (or if JavaScript is loaded late)
document.addEventListener('DOMContentLoaded', initializeLoadMoreButton);

// 7. Bonus: If your section reload can come from other sources, listen to your own events
window.addEventListener('locationchange', initializeLoadMoreButton);
